import Crud from '../views/Configuracao/Crud'
import Entity from '../views/Configuracao/Add'

let routes = {
    path: '/configuracoes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/configuracoes/add',
            name: 'NewConfiguracao',
            component: Entity
        },
        {
            path: '/configuracoes/edit/:id?',
            name: 'EditConfiguracao',
            component: Entity
        },
        {
            path: '/configuracoes',
            name: 'list-configuracoes',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Configurações',
                breadcrumb: [
                    {
                        text: 'Configurações',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
